import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { goal } from "@flights/et-universal";
import { getSearchResultsFlightOffers } from "../store/searchResults/selectors.js";
import useOfferCartOrderData from "./useOfferCartOrderData.js";
const useTrackTop5Offers = () => {
    const offerCartOrderData = useOfferCartOrderData();
    const offers = useSelector(getSearchResultsFlightOffers);
    const top5Tokens = useMemo(() => {
        return offers?.slice(0, 5).map(({ token }) => token) || [];
    }, [offers]);
    const trackTop5OffersClick = useCallback((flightToken) => {
        if (top5Tokens.includes(flightToken)) {
            goal("flights_search_results_top5_offer_clicked");
            offerCartOrderData.set(flightToken, { offer: flightToken, isInTopFiveOffers: true });
        }
    }, [top5Tokens, offerCartOrderData]);
    const trackTop5OffersCheckoutPayment = useCallback((orderToken) => {
        const { isInTopFiveOffers } = offerCartOrderData.get(orderToken);
        if (isInTopFiveOffers) {
            goal("flights_checkout_payment_details_top5_offer_page_view");
        }
    }, [offerCartOrderData]);
    return { trackTop5OffersClick, trackTop5OffersCheckoutPayment };
};
export default useTrackTop5Offers;
